// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

export interface BurstParticle {
    image: () => string;
    left: number;
    top: number;
    width: number;
    delay: number;
}

export const burstStar = (): string => require('images/sticker-collection/burst/star.png');

export const burstParticles: BurstParticle[] = [
    { image: () => require('images/sticker-collection/burst/coin_01.png'), left: 7.75, top: 4.69, width: 12.68, delay: 0.06 },
    { image: () => require('images/sticker-collection/burst/lightning_02.png'), left: 78.17, top: 0, width: 21.83, delay: 0.08 },
    { image: () => require('images/sticker-collection/burst/heart_01.png'), left: 28.87, top: 15.63, width: 7.04, delay: 0.1 },
    { image: () => require('images/sticker-collection/burst/lightning_01.png'), left: 7.04, top: 36.72, width: 16.9, delay: 0.12 },
    { image: () => require('images/sticker-collection/burst/heart_03.png'), left: 0, top: 74.22, width: 27.46, delay: 0.14 },
    { image: () => require('images/sticker-collection/burst/coin_02.png'), left: 35.92, top: 79.69, width: 9.86, delay: 0.16 },
    { image: () => require('images/sticker-collection/burst/heart_02.png'), left: 82.39, top: 82.03, width: 16.2, delay: 0.18 },
];
